export default __webpack_public_path__ + "static/media/hugo.13c5589b.jpg";